var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor ticket-update" }, [
    _c("section", [
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("div", { staticClass: "editor-row-title" }, [_vm._v("Ticket ID")]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Ticket ID",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.ticketId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "ticketId", $$v)
              },
              expression: "clone.ticketId",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("section", [
      _c("div", { staticClass: "title" }, [_vm._v("Updateable Fields")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fields-wrapper" },
        [
          _vm._l(_vm.clone.fields, function (field, index) {
            return _c(
              "div",
              { key: index, staticClass: "field-row" },
              [
                _c(
                  "div",
                  { staticClass: "field-container" },
                  [
                    _c("label", [_vm._v("Field")]),
                    _vm._v(" "),
                    _c("CustomPicker", {
                      attrs: {
                        items: _vm.availableFields,
                        idKey: "name",
                        labelKey: "label",
                        title: "Select Field",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onFieldSelect(field)
                        },
                      },
                      model: {
                        value: field.field,
                        callback: function ($$v) {
                          _vm.$set(field, "field", $$v)
                        },
                        expression: "field.field",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "value-container" },
                  [
                    _c("div", { staticClass: "value-header" }, [
                      _c("label", [_vm._v("Value")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mode-switch" },
                        [
                          _c("span", { staticClass: "switch-label" }, [
                            _vm._v("Dynamic"),
                          ]),
                          _vm._v(" "),
                          _c("a-switch", {
                            attrs: {
                              size: "small",
                              checked: field.mode === "dynamic",
                            },
                            on: {
                              change: function (checked) {
                                return _vm.onModeChange(field, index)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    field.mode === "static"
                      ? [
                          field.field === "status"
                            ? _c("CustomPicker", {
                                attrs: {
                                  items: _vm.statusOptions,
                                  idKey: "title",
                                  labelKey: "title",
                                  placeholder: _vm.getPlaceholderForField(
                                    field.field
                                  ),
                                },
                                model: {
                                  value: field.value,
                                  callback: function ($$v) {
                                    _vm.$set(field, "value", $$v)
                                  },
                                  expression: "field.value",
                                },
                              })
                            : field.field === "rate"
                            ? _c("CustomPicker", {
                                attrs: {
                                  items: _vm.rateOptions,
                                  idKey: "value",
                                  labelKey: "label",
                                  placeholder: _vm.getPlaceholderForField(
                                    field.field
                                  ),
                                },
                                model: {
                                  value: field.value,
                                  callback: function ($$v) {
                                    _vm.$set(field, "value", $$v)
                                  },
                                  expression: "field.value",
                                },
                              })
                            : field.field === "assignedUser"
                            ? _c("CustomPicker", {
                                attrs: {
                                  items: _vm.userOptions,
                                  idKey: "id",
                                  labelKey: "name",
                                  placeholder: _vm.getPlaceholderForField(
                                    field.field
                                  ),
                                },
                                model: {
                                  value: field.value,
                                  callback: function ($$v) {
                                    _vm.$set(field, "value", $$v)
                                  },
                                  expression: "field.value",
                                },
                              })
                            : field.field === "tag"
                            ? _c("TiptapEditor", {
                                attrs: {
                                  placeholder: _vm.getPlaceholderForField(
                                    field.field
                                  ),
                                },
                                model: {
                                  value: field.value,
                                  callback: function ($$v) {
                                    _vm.$set(field, "value", $$v)
                                  },
                                  expression: "field.value",
                                },
                              })
                            : _vm._e(),
                        ]
                      : [
                          _c("TiptapEditor", {
                            attrs: {
                              placeholder: _vm.getPlaceholderForField(
                                field.field
                              ),
                              "automation-mode": "",
                              "show-attributes": true,
                            },
                            model: {
                              value: field.value,
                              callback: function ($$v) {
                                _vm.$set(field, "value", $$v)
                              },
                              expression: "field.value",
                            },
                          }),
                        ],
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: { icon: "", danger: "", xsmall: "" },
                    on: {
                      click: function ($event) {
                        return _vm.removeField(index)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("delete"),
                    ]),
                  ]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.addField } },
            [
              _c("a-icon", { attrs: { type: "plus" } }),
              _vm._v("\n                Add Field\n            "),
            ],
            1
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }